import { createRouter, createWebHistory } from 'vue-router'

import Login from '@/views/Login.vue'
import { isAuthenticated } from '@/services/auth'

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "products-template" */ '@/views/__template.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "products-overview" */ '@/views/Dashboard.vue')
      },
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/products',
    component: () => import(/* webpackChunkName: "products-template" */ '@/views/Products/__template.vue'),
    children: [
      {
        path: '',
        name: 'ProductsOverview',
        component: () => import(/* webpackChunkName: "products-overview" */ '@/views/Products/overview.vue')
      },
      {
        path: 'create',
        name: 'ProductCreate',
        component: () => import(/* webpackChunkName: "product-create" */ '@/views/Products/create.vue')
      },
      {
        path: ':id/edit',
        name: 'ProductEdit',
        component: () => import(/* webpackChunkName: "product-edit" */ '@/views/Products/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    component: () => import(/* webpackChunkName: "orders-template" */ '@/views/Orders/__template.vue'),
    children: [
      {
        path: '',
        name: 'OrdersOverview',
        component: () => import(/* webpackChunkName: "orders-overview" */ '@/views/Orders/overview.vue')
      },
      {
        path: 'create',
        name: 'OrderCreate',
        component: () => import(/* webpackChunkName: "order-create" */ '@/views/Orders/create.vue')
      },
      {
        path: ':id/edit',
        name: 'OrderEdit',
        component: () => import(/* webpackChunkName: "order-edit" */ '@/views/Orders/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    component: () => import(/* webpackChunkName: "categories-template" */ '@/views/Categories/__template.vue'),
    children: [
      {
        path: '',
        name: 'CategoriesOverview',
        component: () => import(/* webpackChunkName: "categories-overview" */ '@/views/Categories/overview.vue')
      },
      {
        path: 'create',
        name: 'CategoryCreate',
        component: () => import(/* webpackChunkName: "category-create" */ '@/views/Categories/create.vue')
      },
      {
        path: ':id/edit',
        name: 'CategoryEdit',
        component: () => import(/* webpackChunkName: "category-edit" */ '@/views/Categories/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/discounts',
    component: () => import(/* webpackChunkName: "discounts-template" */ '@/views/Discounts/__template.vue'),
    children: [
      {
        path: '',
        name: 'DiscountsOverview',
        component: () => import(/* webpackChunkName: "discounts-overview" */ '@/views/Discounts/overview.vue')
      },
      {
        path: 'create',
        name: 'DiscountCreate',
        component: () => import(/* webpackChunkName: "discount-create" */ '@/views/Discounts/create.vue')
      },
      {
        path: ':id/edit',
        name: 'DiscountEdit',
        component: () => import(/* webpackChunkName: "discount-edit" */ '@/views/Discounts/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/cities',
    component: () => import(/* webpackChunkName: "cities-template" */ '@/views/Cities/__template.vue'),
    children: [
      {
        path: '',
        name: 'CitiesOverview',
        component: () => import(/* webpackChunkName: "cities-overview" */ '@/views/Cities/overview.vue')
      },
      {
        path: 'create',
        name: 'CityCreate',
        component: () => import(/* webpackChunkName: "city-create" */ '@/views/Cities/create.vue')
      },
      {
        path: ':id/edit',
        name: 'CityEdit',
        component: () => import(/* webpackChunkName: "city-edit" */ '@/views/Cities/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/roles',
    component: () => import(/* webpackChunkName: "roles-template" */ '@/views/Roles/__template.vue'),
    children: [
      {
        path: '',
        name: 'RolesOverview',
        component: () => import(/* webpackChunkName: "roles-overview" */ '@/views/Roles/overview.vue')
      },
      {
        path: 'create',
        name: 'RoleCreate',
        component: () => import(/* webpackChunkName: "role-create" */ '@/views/Roles/create.vue')
      },
      {
        path: ':id/edit',
        name: 'RoleEdit',
        component: () => import(/* webpackChunkName: "role-edit" */ '@/views/Roles/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/clients',
    component: () => import(/* webpackChunkName: "clients-template" */ '@/views/Clients/__template.vue'),
    children: [
      {
        path: '',
        name: 'ClientsOverview',
        component: () => import(/* webpackChunkName: "clients-overview" */ '@/views/Clients/overview.vue')
      },
      {
        path: 'create',
        name: 'ClientCreate',
        component: () => import(/* webpackChunkName: "client-create" */ '@/views/Clients/create.vue')
      },
      {
        path: ':id/edit',
        name: 'ClientEdit',
        component: () => import(/* webpackChunkName: "client-edit" */ '@/views/Clients/edit.vue'),
        props: true
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    component: () => import(/* webpackChunkName: "profile-template" */ '@/views/Profile/__template.vue'),
    children: [
      {
        path: '',
        name: 'ProfileOverview',
        component: () => import(/* webpackChunkName: "profile-overview" */ '@/views/Profile/overview.vue')
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    component: () => import(/* webpackChunkName: "settings-template" */ '@/views/__template.vue'),
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "settings-overview" */ '@/views/Settings.vue')
      }
    ],
    meta: { requiresAuth: true }
  }
  ,{
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Global navigation guard
router.beforeEach((to, from, next) => {
  if (to.meta?.requiresAuth) {
    if (isAuthenticated()) {
      next()
    } else {
      // Preserve intended route in query param for post-login redirect
      next({ name: 'Login', query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})

export default router